// extracted by mini-css-extract-plugin
var _1 = "nJC2E";
export { _1 as "summarizeError" }
